<template>
    <tr
        v-if="isEditable"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ honor.parameterValue.value }}
        </td>
        <td class="kgr-table__cell">
            <div
                class="form-widget without-label date-picker"
                :class="{ invalid: !editHonor.on }"
            >
                <kgr-date-picker
                    v-model="editHonor.on"
                />
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                :size="15"
                disabled
                class="kgr-table__action"
            />
            <kgr-icon-delete
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker';
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import MemberHonor from '../../../js/dto/MemberHonor';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        honor: {
            type: MemberHonor,
            required: true
        },
        editHonors: {
            type: Array,
            required: true
        },
    },
    computed: {
        isEditable() {
            return this.editIndex !== -1;
        },
        editIndex() {
            return this.editHonors.map(editHonor => editHonor.id).indexOf(this.honor.id);
        },
        editHonor() {
            return this.editHonors[this.editIndex];
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .kgr-table__cell  {
        vertical-align: top;
    }

    .date-picker {
        border: 1px solid transparent;

        &.invalid {
            border: 1px solid #F44336;
        }
    }
</style>
